'use client'

import { useTranslations } from 'next-intl'
import ContentWrapper from '../../../components/ui/ContentWrapper'
import StepAccordion from './StepAccordion'

const Steps = () => {
  const t = useTranslations('process')
  // Mobiles Akkordeon aus denselben i18n-Keys wie die Desktop-Liste; vorher stand hier
  // eine deutsche Konstante, die auch auf /en deutsch ausgeliefert wurde.
  const steps = ([1, 2, 3, 4] as const).map((stepNumber) => ({
    stepNumber,
    title: t(`step${stepNumber}.title`),
    content: t(`step${stepNumber}.description`)
  }))
  return (
    <ContentWrapper tag="section" className="lg:gap-x-8 mt-24 lg:mt-32 relative  rounded-3xl border border-accent p-12 lg:p-16 overflow-hidden mb-16">
      <div className="absolute top-0 left-0 w-full h-full bg-accent opacity-75 z-1" />
      <figure className='absolute top-0 left-0 w-full h-full bg-cover bg-fixed lg:bg-local bg-center bg-[url("/images/backgrounds/Flower-BG-Orange-01.jpg")]' />
      <article className="col-span-full lg:col-span-6 z-2">
        <h3 className="font-light text-sm leading-[14px] mb-8">{t('title')}</h3>
        <h2 className="font-medium text-2xl lg:text-[32px] leading-[100%] lg:leading-[14px]">{t('subtitle')}</h2>
        <p className="mt-12 lg:mt-16 text-lg leading-6 font-light">
          {t('step1.description')} <br />
          <br />
          {t('step2.description')}
        </p>
      </article>
      <ul className="hidden col-span-full lg:grid grid-cols-12 z-2 mt-16 lg:gap-8">
        <li className="col-span-3 flex flex-col">
          <div className="w-[30px] h-[30px] bg-accent rounded-full flex justify-center items-center mb-8">
            <p className="font-bold text-sm leading-none">1</p>
          </div>
          <div>
            <h3 className="text-2xl leading-6 font-light mb-8">{t('step1.title')}</h3>
            <p className="text-lg leading-6 font-light">{t('step1.description')}</p>
          </div>
        </li>
        <li className="col-span-3 flex flex-col">
          <div className="w-[30px] h-[30px] bg-accent rounded-full flex justify-center items-center mb-8">
            <p className="font-bold text-sm leading-none">2</p>
          </div>
          <div>
            <h3 className="text-2xl leading-6 font-light mb-8">{t('step2.title')}</h3>
            <p className="text-lg leading-6 font-light">{t('step2.description')}</p>
          </div>
        </li>
        <li className="col-span-3 flex flex-col">
          <div className="w-[30px] h-[30px] bg-accent rounded-full flex justify-center items-center mb-8">
            <p className="font-bold text-sm leading-none">3</p>
          </div>
          <div>
            <h3 className="text-2xl leading-6 font-light mb-8">{t('step3.title')}</h3>
            <p className="text-lg leading-6 font-light">{t('step3.description')}</p>
          </div>
        </li>
        <li className="col-span-3 flex flex-col">
          <div className="w-[30px] h-[30px] bg-accent rounded-full flex justify-center items-center mb-8">
            <p className="font-bold text-sm leading-none">4</p>
          </div>
          <div>
            <h3 className="text-2xl leading-6 font-light mb-8">{t('step4.title')}</h3>
            <p className="text-lg leading-6 font-light">{t('step4.description')}</p>
          </div>
        </li>
      </ul>
      <ul className="lg:hidden z-2 mt-16 col-span-full [&>li:last-child>div>div_p]:pt-8 [&>li:last-child>div>div_p]:pb-0 [&>li:last-child_button]:pb-0">
        {steps.map((item) => (
          <StepAccordion key={item.stepNumber} data={item} />
        ))}
      </ul>
    </ContentWrapper>
  )
}

export default Steps
